module.exports = __webpack_public_path__ + "static/img/nodata.80358d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nodata.png
// module id = 219
// module chunks = 379 380